import React from 'react';
import { Box } from '@mui/material';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

interface MedicalIconProps {
  size?: number;
  color?: string;
}

const MedicalIcon: React.FC<MedicalIconProps> = ({ 
  size = 48, 
  color = '#1976d2' 
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: size + 20,
        height: size + 20,
        borderRadius: '50%',
        backgroundColor: 'rgba(25, 118, 210, 0.08)',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          border: '1px solid rgba(25, 118, 210, 0.15)',
        }
      }}
    >
      <LocalHospitalIcon
        sx={{
          fontSize: size,
          color: color,
          opacity: 0.9,
        }}
      />
    </Box>
  );
};

export default MedicalIcon;